import { FileText, FileSpreadsheet, Image, FileVideo, FileArchive, Music, File } from 'lucide-react';

// Jednolity kolor brandu dla wszystkich ikon plików
const ICON_COLOR = '#7c3aed';
const ICON_BG = 'rgba(139,92,246,0.12)';

// Zwraca komponent ikony pasujący do typu pliku (kolor jednolity)
export function getFileIcon(name) {
  const ext = ((name || '').split('.').pop() || '').toLowerCase();
  const iconMap = {
    pdf: FileText, doc: FileText, docx: FileText, txt: FileText, ppt: FileText, pptx: FileText,
    xls: FileSpreadsheet, xlsx: FileSpreadsheet, csv: FileSpreadsheet,
    png: Image, jpg: Image, jpeg: Image, gif: Image, webp: Image,
    mp4: FileVideo, mov: FileVideo,
    mp3: Music,
    zip: FileArchive, rar: FileArchive,
  };
  const Icon = iconMap[ext] || File;
  return { Icon, color: ICON_COLOR, bg: ICON_BG };
}

// Gotowy kolorowy box z ikoną pliku
export function FileIcon({ name, size = 18, boxSize = 36 }) {
  const { Icon, color, bg } = getFileIcon(name);
  return (
    <div style={{ width: boxSize, height: boxSize, minWidth: boxSize, borderRadius: '9px', boxShadow: `inset 0 0 0 ${boxSize}px ${bg}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: color, flexShrink: 0 }}>
      <Icon size={size} strokeWidth={1.75} />
    </div>
  );
}